import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import styles from './index.module.scss';
import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';

const IMAGE_CONFIG = {
    jp: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1749436591070/pc_JP.jpg',
        pad: 'https://websiteoss.ecoflow.com/upload/image/1749436591070/pc_JP.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1749436451711/m_JP.jpg',
    },
    other: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1749436452226/pc_other.jpg',
        pad: 'https://websiteoss.ecoflow.com/upload/image/1749436452226/pc_other.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1749436451993/m_other.jpg',
    },
};

export default function TheComp() {
    const { t } = useLang('rapidseries.brand');
    const { locale = 'us' } = useRouter();
    const [enter, setEnter] = useState(false);

    const parseTitle = (title: string) => {
        // 匹配数字和单位
        const numberMatch = title.match(/(\d[\d,. ]*)/);
        if (!numberMatch) return { num: 0, prefix: '', suffix: '' };

        const numStr = numberMatch[1].trim();
        const num = parseFloat(numStr.replace(/[^\d.]/g, ''));

        // 分割前缀和后缀
        const [beforeNum, afterNum] = title.split(numStr);

        return {
            num,
            prefix: beforeNum.trim(),
            suffix: afterNum?.trim() || '',
        };
    };

    const items = [
        {
            title: t('item1_title'),
            ...parseTitle(t('item1_title')),
            devide: 5,
            desc: t('item1_desc'),
            icon: <Step1 />,
        },
        {
            title: t('item2_title'),
            ...parseTitle(t('item2_title')),
            devide: 10,
            desc: t('item2_desc'),
            icon: <Step2 />,
        },
        {
            title: t('item3_title'),
            ...parseTitle(t('item3_title')),
            devide: 15,
            desc: t('item3_desc'),
            icon: <Step3 />,
        },
        {
            title: t('item4_title'),
            ...parseTitle(t('item4_title')),
            devide: 5,
            desc: t('item4_desc'),
            icon: <Step4 />,
        },
    ];

    const images = locale === 'jp' ? IMAGE_CONFIG.jp : IMAGE_CONFIG.other;
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const observer = new IntersectionObserver((entries: any[]) => {
                entries.forEach((entry: { isIntersecting: any; target: { classList: string[] } }) => {
                    if (entry.isIntersecting && entry.target.classList[0] === 'itemsContainer' && !enter) {
                        setEnter(true);
                    } else {
                        setEnter(false);
                    }
                });
            });
            const sectionB: HTMLDivElement | null = document.querySelector('.itemsContainer');
            if (sectionB) {
                observer.observe(sectionB);
            }
        }
    }, []);

    return (
        <div className={styles.TheComp}>
            <div className="banner">
                <div className="banner-image">
                    <EcoImg pc={images.pc} pad={images.pad} h5={images.h5} />
                </div>
                <div className="banner-content">
                    {locale !== 'jp' && (
                        <>
                            <div className="content">
                                <h1 className="title">{t('title')}</h1>
                                <p className="desc">{t('desc')}</p>
                            </div>
                            <div className={`itemsContainer${enter ? ' enter' : ''}`}>
                                {items.map((item, index) => (
                                    <div key={index} className="item">
                                        <div className="item-icon">{item.icon}</div>
                                        <div className="item-ani">
                                            <div className="number-container">
                                                {item?.prefix && <span className="item-prefix">{item.prefix} </span>}
                                                <ul
                                                    className="item-arr"
                                                    style={{
                                                        transform: enter ? `translateY(-${(item.devide - 1) * 100}%)` : '0',
                                                        transition: enter ? `transform ${item.devide * 0.2}s ease-in-out` : 'none',
                                                    }}
                                                >
                                                    {Array.from({ length: item.devide }, (_, i) => {
                                                        const value = (i + 1) * (item.num / item.devide);
                                                        return (
                                                            <li className="item-li" key={`${index}_${i}`} style={{ height: '24px' }}>
                                                                {/* {Number.isInteger(value) ? value.toString() : value.toFixed(1)} */}
                                                                {Number.isInteger(value)
                                                                    ? new Intl.NumberFormat('en-US', { useGrouping: true }).format(value).replace(/,/g, ' ')
                                                                    : new Intl.NumberFormat('en-US', {
                                                                          useGrouping: true,
                                                                          minimumFractionDigits: 1,
                                                                          maximumFractionDigits: 1,
                                                                      })
                                                                          .format(value)
                                                                          .replace(/,/g, ' ')}
                                                            </li>
                                                        );
                                                    })}
                                                </ul>
                                                {item?.suffix && <span className="item-suffix">{item.suffix}</span>}
                                            </div>
                                        </div>
                                        <p className="item-text">{item.desc}</p>
                                    </div>
                                ))}
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
